import { render } from "./PracticeDetails.vue?vue&type=template&id=6aec2979"
import script from "./PracticeDetails.vue?vue&type=script&lang=js"
export * from "./PracticeDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__